import React from "react";
import { Input } from "../Input";

interface Step1Props {
  handleChange: any;
  errors: any;
  values: any;
}

export function Step1({ errors, handleChange, values }: Step1Props) {
  return (
    <div>
      <Input
        name="name"
        onChange={handleChange}
        label="Nome e Sobrenome"
        error={errors.name}
        value={values.name}
      />
      <div className="flex">
        <div className="col">
          <Input
            label="Data de nascimento"
            name="birthDate"
            inputMode="numeric"
            maxLength={10}
            onChange={handleChange}
            mask="99/99/9999"
            error={errors.birthDate}
            value={values.birthDate}
          />
        </div>

        <div className="col">
          <Input
            label="CPF"
            name="cpf"
            inputMode="numeric"
            maxLength={14}
            onChange={handleChange}
            mask="999.999.999-99"
            error={errors.cpf}
            value={values.cpf}
          />
        </div>
      </div>

      <div className="flex">
        <div className="col">
          <Input
            label="E-mail"
            name="email"
            inputMode="email"
            onChange={handleChange}
            error={errors.email}
            value={values.email}
          />
        </div>

        <div className="col">
          <Input
            label="Telefone"
            name="phone"
            mask="(99) 99999-9999"
            maxLength={15}
            onChange={handleChange}
            error={errors.phone}
            inputMode="numeric"
            value={values.phone}
          />
        </div>
      </div>
    </div>
  );
}
